import { render, staticRenderFns } from "./PatinetProfileRatesStatistic.vue?vue&type=template&id=3c16eeaa&scoped=true&"
import script from "./PatinetProfileRatesStatistic.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatinetProfileRatesStatistic.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PatinetProfileRatesStatistic.vue?vue&type=style&index=0&id=3c16eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16eeaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c16eeaa')) {
      api.createRecord('3c16eeaa', component.options)
    } else {
      api.reload('3c16eeaa', component.options)
    }
    module.hot.accept("./PatinetProfileRatesStatistic.vue?vue&type=template&id=3c16eeaa&scoped=true&", function () {
      api.rerender('3c16eeaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/common/PatinetProfileRatesStatistic.vue"
export default component.exports